import owd from 'owd/owd';

export default class Modal extends owd.Component {
	init() {
        this.closeButton = this.$element.find('.button--close');
		this.bind();
	}

	bind() {
		this.on('click', this.closeButton, () => {
            this.$element.removeClass('is-visible'); 
        });
	}
}

owd.registerComponent('Modal', {
	component: Modal
});